import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import TransactionViewModel from "@/viewmodels/app/TransactionViewModel";

// Create an instance of the ViewModel

export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsComponent',
  setup(__props) {

const viewModel = new TransactionViewModel();

// Método para manejar el scroll
function handleScroll(tab: string, event: Event): void {
  const target = event.target as HTMLElement;

  if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
    if (tab === "aportes") {
      viewModel.loadMoreAportes();
    } else if (tab === "creditos") {
      viewModel.loadMoreCreditos();
    } else if (tab === "ahorros") {
      viewModel.loadMoreAhorros();
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_breadcrumbs, {
              class: "text-caption py-0 px-0",
              items: _unref(viewModel).breadcrumbs
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-chart-bar",
                  size: "small"
                })
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _unref(viewModel).tab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(viewModel).tab.value) = $event)),
                  color: "primary",
                  direction: "horizontal",
                  height: "60",
                  grow: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, {
                      class: "text-none",
                      "prepend-icon": "mdi-hand-heart",
                      text: "Aportes",
                      value: "aportes"
                    }),
                    _createVNode(_component_v_tab, {
                      class: "text-none",
                      "prepend-icon": "mdi-wallet",
                      text: "Créditos",
                      value: "creditos"
                    }),
                    _createVNode(_component_v_tab, {
                      class: "text-none",
                      "prepend-icon": "mdi-circle-multiple",
                      text: "Ahorros",
                      value: "ahorros"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tabs_window, {
              modelValue: _unref(viewModel).tab.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(viewModel).tab.value) = $event)),
              transition: "none"
            }, {
              default: _withCtx(() => [
                (_unref(viewModel).tab.value === 'aportes')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 0,
                      value: "aportes"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _unref(viewModel).searchAportes.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(viewModel).searchAportes.value) = $event)),
                          label: "Buscar Aportes",
                          "clear-icon": "mdi-close-circle",
                          variant: "outlined",
                          clearable: "",
                          density: "compact",
                          "prepend-inner-icon": "mdi-magnify",
                          class: "my-2",
                          "hide-details": "",
                          "onClick:clear": _unref(viewModel).clearSearchAportes
                        }, null, 8, ["modelValue", "onClick:clear"]),
                        _createVNode(_component_v_card, {
                          flat: "",
                          border: "",
                          class: "pa-4 text-start rounded-sm overflow-y-auto",
                          style: {"height":"calc(100vh - 271px)"},
                          onScroll: _cache[2] || (_cache[2] = (e) => handleScroll('aportes', e))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_unref(viewModel).loading.value)
                                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                                          return _createVNode(_component_v_skeleton_loader, {
                                            class: "mx-4 my-2",
                                            type: "list-item-two-line",
                                            key: 'skeleton-contribution-' + n
                                          })
                                        }), 64))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel)
                  .filteredContribTransactions.value, (transaction, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    class: "pa-4 mb-2 border-b-sm",
                                    style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_avatar, {
                                        rounded: "lg",
                                        size: "48",
                                        variant: "tonal",
                                        color: _unref(viewModel).getColor(transaction.tipomov)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "20" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(transaction.tipomov)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.concepto), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2 py-1" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.fecha) + " - " + _toDisplayString(transaction.hora), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_list_item_subtitle, {
                                        class: _normalizeClass(["text-subtitle-1 font-weight-bold", `text-${_unref(viewModel).getColor(transaction.tipomov)}`])
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_unref(viewModel).formatCoin(transaction.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(transaction.saldo)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            (!_unref(viewModel).filteredContribTransactions.value?.length)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "info",
                                  variant: "tonal",
                                  class: "text-center text-subtitle-2",
                                  border: "",
                                  text: "No hay movimientos de aportes para mostrar."
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(viewModel).tab.value === 'creditos')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 1,
                      value: "creditos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _unref(viewModel).searchCreditos.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(viewModel).searchCreditos.value) = $event)),
                          label: "Buscar Créditos",
                          "clear-icon": "mdi-close-circle",
                          variant: "outlined",
                          clearable: "",
                          density: "compact",
                          "prepend-inner-icon": "mdi-magnify",
                          class: "my-2",
                          "hide-details": "",
                          "onClick:clear": _unref(viewModel).clearSearchCreditos
                        }, null, 8, ["modelValue", "onClick:clear"]),
                        _createVNode(_component_v_card, {
                          flat: "",
                          border: "",
                          class: "pa-4 text-start rounded-sm overflow-y-auto",
                          style: {"height":"calc(100vh - 271px)"},
                          onScroll: _cache[4] || (_cache[4] = (e) => handleScroll('creditos', e))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel)
                  .filteredCreditTransactions.value, (transaction, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    class: "pa-4 mb-2 border-b-sm",
                                    style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_avatar, {
                                        rounded: "lg",
                                        size: "48",
                                        variant: "tonal",
                                        color: _unref(viewModel).getColor(transaction.tipomov)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "20" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(transaction.tipomov)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.concepto), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2 py-1" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.fecha) + " - " + _toDisplayString(transaction.hora), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_list_item_subtitle, {
                                        class: _normalizeClass(["text-subtitle-1 font-weight-bold", `text-${_unref(viewModel).getColor(transaction.tipomov)}`])
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_unref(viewModel).formatCoin(transaction.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(transaction.saldo)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            (!_unref(viewModel).filteredCreditTransactions.value.length)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "info",
                                  variant: "tonal",
                                  class: "text-center text-subtitle-2",
                                  border: "",
                                  text: "No hay movimientos de créditos para mostrar."
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(viewModel).tab.value === 'ahorros')
                  ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                      key: 2,
                      value: "ahorros"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _unref(viewModel).searchAhorros.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(viewModel).searchAhorros.value) = $event)),
                          label: "Buscar Ahorros",
                          "clear-icon": "mdi-close-circle",
                          variant: "outlined",
                          clearable: "",
                          density: "compact",
                          "prepend-inner-icon": "mdi-magnify",
                          class: "my-2",
                          "hide-details": "",
                          "onClick:clear": _unref(viewModel).clearSearchAhorros
                        }, null, 8, ["modelValue", "onClick:clear"]),
                        _createVNode(_component_v_card, {
                          flat: "",
                          border: "",
                          class: "pa-4 text-start rounded-sm overflow-y-auto",
                          style: {"height":"calc(100vh - 271px)"},
                          onScroll: _cache[6] || (_cache[6] = (e) => handleScroll('ahorros', e))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel)
                  .filteredSaverTransactions.value, (transaction, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: index,
                                    class: "pa-4 mb-2 border-b-sm",
                                    style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_avatar, {
                                        rounded: "lg",
                                        size: "48",
                                        variant: "tonal",
                                        color: _unref(viewModel).getColor(transaction.tipomov)
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { size: "20" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(transaction.tipomov)), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.concepto), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2 py-1" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(transaction.fecha) + " - " + _toDisplayString(transaction.hora), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_list_item_subtitle, {
                                        class: _normalizeClass(["text-subtitle-1 font-weight-bold", `text-${_unref(viewModel).getColor(transaction.tipomov)}`])
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("strong", null, _toDisplayString(_unref(viewModel).formatCoin(transaction.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(transaction.saldo)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }),
                            (!_unref(viewModel).filteredSaverTransactions.value.length)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "info",
                                  variant: "tonal",
                                  class: "text-center text-subtitle-2",
                                  border: "",
                                  text: "No hay movimientos de ahorros para mostrar."
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})